export const LOGIN_SAGA = 'LOGIN_SAGA';
export const LOGOUT_SAGA = 'LOGOUT_SAGA';

export const CREATE_USER_SAGA = 'CREATE_USER_SAGA';
export const ADMIN_CREATE_USER_SAGA = 'ADMIN_CREATE_USER_SAGA';
export const ADMIN_CREATE_USER_SPONSOR_SAGA = 'ADMIN_CREATE_USER_SPONSOR_SAGA';
export const UPDATE_USER_SAGA = 'UPDATE_USER_SAGA';
export const LOAD_CURRENT_USER_SAGA = 'LOAD_CURRENT_USER_SAGA';
export const UPDATE_URL_USER_SAGA = 'UPDATE_URL_USER_SAGA';


export const API_ERROR_SAGA = 'API_ERROR_SAGA';
export const VALIDATE_ERROR_SAGA = 'VALIDATE_ERROR_SAGA';

export const FORGOT_PASSWORD_SAGA = 'FORGOT_PASSWORD_SAGA';
export const NEW_PASSWORD_SAGA = 'NEW_PASSWORD_SAGA';
export const CHANGE_PASSWORD_SAGA = 'CHANGE_PASSWORD_SAGA';

export const LOAD_WEBINARS_SAGA = 'LOAD_WEBINARS_SAGA';
export const RELOAD_ALL_DASHBOARD_WEBINARS_SAGA = 'RELOAD_ALL_DASHBOARD_WEBINARS_SAGA';
export const LOAD_WEBINAR_SAGA = 'LOAD_WEBINAR_SAGA';
export const LOAD_USERS_WEBINARS_SAGA = 'LOAD_USERS_WEBINARS_SAGA';

export const SUBSCRIBE_WEBINAR_SAGA = 'SUBSCRIBE_WEBINAR_SAGA';
export const UNSUBSCRIBE_WEBINAR_SAGA = 'UNSUBSCRIBE_WEBINAR_SAGA';
export const JOIN_WEBINAR_SAGA = 'JOIN_WEBINAR_SAGA';
export const JOIN_WEBINAR_FROM_LINK_SAGA = 'JOIN_WEBINAR_FROM_LINK_SAGA';

export const CREATE_WEBINAR_SAGA = 'CREATE_WEBINAR_SAGA';
export const UPDATE_WEBINAR_SAGA = 'UPDATE_WEBINAR_SAGA';
export const DELETE_WEBINAR_SAGA = 'DELETE_WEBINAR_SAGA';

export const LOAD_SUBSCRIPTIONS_SAGA = 'LOAD_SUBSCRIPTIONS_SAGA';

export const LOAD_VIMEO_VIDEO_DATA_SAGA = 'LOAD_VIMEO_VIDEO_DATA_SAGA';

export const CHECK_ANSWERS_SAGA = 'CHECK_ANSWERS_SAGA';

export const LOAD_HOSPITALS_SAGA = 'LOAD_HOSPITALS_SAGA';
export const LOAD_COUNTIES_SAGA = 'LOAD_COUNTIES_SAGA';
export const LOAD_SPONSORS_SUGGESTIONS_SAGA = 'LOAD_SPONSORS_SUGGESTIONS_SAGA';

export const CONFIRM_EMAIL_SAGA = 'CONFIRM_EMAIL_SAGA';

export const LOAD_ADMIN_USERS_SAGA = 'LOAD_ADMIN_USERS_SAGA';
export const ADMIN_DELETE_USERS_SAGA = 'ADMIN_DELETE_USERS_SAGA';
export const ADMIN_DELETE_WEBINARS_SAGA = 'ADMIN_DELETE_WEBINARS_SAGA';
export const LOAD_EDIT_USER_SAGA = 'LOAD_EDIT_USER_SAGA';
export const ADMIN_UPDATE_USER_SAGA = 'ADMIN_UPDATE_USER_SAGA';
export const LOAD_ADMIN_WEBINARS_SAGA = 'LOAD_ADMIN_WEBINARS_SAGA';
export const LOAD_ADMIN_WEBINAR_SAGA = 'LOAD_ADMIN_WEBINAR_SAGA';
export const LOAD_ADMIN_USRES_WEBINARS_SAGA = 'LOAD_ADMIN_USRES_WEBINARS_SAGA';
export const LOAD_ADMIN_DASHBOARD_WEBINARS_SAGA = 'LOAD_ADMIN_DASHBOARD_WEBINARS_SAGA';
export const LOAD_ADMIN_DASHBOARD_USERS_SAGA = 'LOAD_ADMIN_DASHBOARD_USERS_SAGA';
export const USER_FILTER_SAGA = 'USER_FILTER_SAGA';
export const SHOW_DASHBOARD_MODAL_SAGA = 'SHOW_DASHBOARD_MODAL_SAGA';
export const UPDATE_MODAL_DATA = 'UPDATE_MODAL_DATA';

export const LOAD_ADMIN_SPONSORS_SAGA = 'LOAD_ADMIN_SPONSORS_SAGA';
export const UPDATE_SPONSOR_SAGA = 'UPDATE_SPONSOR_SAGA';
export const ADMIN_DELETE_SPONSORS_SAGA = 'ADMIN_DELETE_SPONSORS_SAGA';
export const CREATE_SPONSOR_SAGA = 'CREATE_SPONSOR_SAGA';
export const LOAD_SPONSORS_SAGA = 'LOAD_SPONSORS_SAGA';
export const LOAD_SPONSOR_SAGA = 'LOAD_SPONSOR_SAGA';
export const USER_SPONSOR_FILTER_SAGA = 'USER_SPONSOR_FILTER_SAGA';



/** WEBPACK FOOTER **
 ** ./src/constants/sagas.js
 **/